import inViewport from '@resources/js/helpers/inViewport';
const faqSectionElement = document.querySelector('.js-attraction-faq');
inViewport(faqSectionElement, async () => {
    const faqQuestionElements = faqSectionElement.querySelectorAll('.js-faq-question');
    if (!faqQuestionElements.length)
        return;
    const { default: Accordion } = await import('@resources/js/ui/Accordion');
    const { isMobile } = await import('@resources/js/helpers/media');
    const isMobileView = isMobile();
    const faqAccordion = new Accordion(faqQuestionElements, {
        multiple: !isMobileView,
        behavior: 'smooth',
        allowCopy: true,
    });
    if (!isMobileView)
        faqAccordion.closeAll();
    faqAccordion.open(0);
});
